export const wikiData = [
  {
    id: 0,
    text: 'Windows 95 is a consumer-oriented operating system developed by Microsoft as part of its Windows 9x family of operating systems.',
  },
  {
    id: 1,
    text: 'Windows 95 merged Microsoft"s formerly separate MS-DOS and Microsoft Windows products, and featured significant improvements over its predecessor, most notably in the graphical user interface (GUI) and in its simplified "plug-and-play" features.',
  },
  {
    id: 2,
    text: 'Accompanied by an extensive marketing campaign, Windows 95 introduced numerous functions and features that were featured in later Windows versions, and continue in modern variations to this day, such as the taskbar, notification area, and the "Start" button.',
  },
  {
    id: 3,
    text: 'It is considered to be one of the biggest and most important products in the personal computing industry.',
  },
  {
    id: 4,
    text: 'Three years after its introduction, Windows 95 was followed by Windows 98. Nevertheless, Windows 95 remained the most popular operating system in 1998, despite the release of Windows 98. Microsoft ended mainstream support for Windows 95 on December 31, 2000.',
  },
]
